import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment-timezone";
import Datetime from "react-datetime";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  FormCheck,
  InputGroup,
} from "@themesberg/react-bootstrap";
import Select from "react-select";
import { useParams } from "react-router-dom";
import axios from "axios";
import {
  createReminder,
  getReminder,
  updateReminder,
  getVendorList,
} from "../../app/api";
import swal from "sweetalert";
import Loader from "../../components/Loader";
import { useHistory } from "react-router-dom";
import { Routes } from "../../routes";
import Loadericon from "../../components/Loadericon";
export default () => {
  const { id } = useParams();
  const history = useHistory();
  // console.log("Reminder ID from URL:", id);
  const [frequency, setFrequency] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescritpion] = useState("");
  const [date, setDate] = useState("");
  const [reminder, setReminder] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [vendor, setVendor] = useState([]);
  const [vendorId, setVendorID] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingBtn(true);
    // console.log("Reminder state:", reminder);
    const formattedDate = date ? moment(date).format("YYYY-MM-DDTHH:mm:ssZ") : null;
    try {
      const token = localStorage.getItem("token");

      const reminderData = {
        title,
        vendor_id: vendorId,

        due_date: formattedDate,
        email_reminder: reminder ? "0" : "1",
        frequency,
        description,
      };
      let response;
      if (id) {
        response = await axios.put(updateReminder(id), reminderData, {
          headers: {
            "Content-Type": "application/json",
            "secret-key": process.env.REACT_APP_SECRET_KEY,
            "auth-token": `Bearer ${token}`,
          },
        });

        swal({
          text: response.data.message,
          icon: "success",
        }).then(() => {
          history.push(Routes.Reminder.path);
        });
      } else {
        response = await axios.post(createReminder(), reminderData, {
          headers: {
            "Content-Type": "application/json",
            "secret-key": process.env.REACT_APP_SECRET_KEY,
            "auth-token": `Bearer ${token}`,
          },
        });
        swal({
          text: response.data.message,
          icon: "success",
        });
     
          setFrequency("");
          setTitle("");
          setDescritpion("");
          setDate("");
          setReminder(false);
          setVendorID("");
      
      }

      // console.log(response.data);
    } catch (err) {
      // console.error(err);
      swal({
        text: err.response.data.messages.error,
        icon: "error",
      });
    } finally {
      setLoadingBtn(false);
     
    }
  };
  const fetchSingleAssets = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(getReminder(id), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });
      // console.log(response.data);
      setFrequency(response.data?.data?.frequency);
      setTitle(response.data?.data?.title);
      setDescritpion(response.data?.data?.description);
      setDate(response.data?.data?.due_date);
      setReminder(response.data?.data?.email_reminder);
      setVendorID(response.data?.data?.vendor_id);
    } catch (error) {
      // console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSingleAssets();
  }, [id]);
  useEffect(() => {
    const fetchvendorsList = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        const response = await axios.get(getVendorList(), {
          headers: {
            "secret-key": process.env.REACT_APP_SECRET_KEY,
            "auth-token": `Bearer ${token}`,
          },
        });
        // console.log("vendor dropdown", response.data?.data);
        setVendor(response.data?.data);
      } catch (error) {
        console.error("Error fetching vendors:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchvendorsList();
  }, []);
  const handleBackClick = () => {
    history.push(Routes.Reminder.path);
  };
  const vendorList = vendor.map((v) => ({
    value: v.id,
    label: v.company_name,
  }));
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
            <div className="d-block  mb-md-0">
              {/* <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Back</Breadcrumb.Item>
            <Breadcrumb.Item active>{id? "Update Reminders ":"Create Reminders"}</Breadcrumb.Item>
          </Breadcrumb> */}
              <h4 className="mb-0">Reminders</h4>
            </div>
          </div>

          <Row className="justify-content-md-center">
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              <Card border="light" className="shadow-sm">
                <Card.Body>
                  <Card.Title>
                    {id ? "Update Reminder" : "Create a New Reminder"}
                  </Card.Title>

                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group id="Title">
                          <Form.Label>Title</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Title"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      {/* <Col md={6} className="mb-3">
                        <Form.Group id="Vendor Name">
                          <Form.Label>Vendor Name</Form.Label>
                          <Form.Select
                            value={vendorId}
                            onChange={(e) => setVendorID(e.target.value)}
                          >
                            <option value="0">Select Vendor</option>
                            {vendor.map((v) => (
                              <option key={v.id} value={v.id}>
                                {v.company_name}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col> */}
                        <Col md={6} className="mb-3">
                                            <Form.Group id="Vendor Name">
                                            <Form.Label>Vendor Name</Form.Label>
                                            <Select
                                           
                                        options={vendorList}
                                        placeholder="Select Vendor"
                                        value={
                                          vendorList.find((option) => option.value === vendorId) ||
                                          null
                                        }
                                       
                                        onChange={(selectedOption) => {
                                          setVendorID(selectedOption.value);
                                        }}
                                        styles={{
                                          container: (base) => ({
                                            ...base,
                                            borderRadius: "5px",
                                            width: "100%",
                                          }),
                                        }}
                                      />
                                      </Form.Group>
                                      </Col>
                    </Row>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group id="Frequency ">
                          <Form.Label>Frequency </Form.Label>
                          <Form.Select
                            value={frequency}
                            onChange={(e) => setFrequency(e.target.value)}
                          >
                            <option value="">Select an Frequency</option>

                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">after due</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group id="Due Date">
                          <Form.Label>Due Date</Form.Label>
                          <Datetime
                            timeFormat={true}
                            onChange={(e) => setDate(e)}
                            renderInput={(props, openCalendar) => (
                              <InputGroup>
                                <InputGroup.Text>
                                  <FontAwesomeIcon icon={faCalendarAlt} />
                                </InputGroup.Text>
                                <Form.Control
                                  required
                                  type="text"
                                  value={
                                    date
                                      ? moment(date).format("MM/DD/YYYY HH/MM")
                                      : ""
                                  }
                                  placeholder="mm/dd/yyyy hh/mm"
                                  onFocus={openCalendar}
                                  onChange={() => {}}
                                />
                              </InputGroup>
                            )}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row></Row>

                    <Col md={12} className="mb-3">
                      <Form.Group id="Description">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          placeholder="Enter Description"
                          value={description}
                          onChange={(e) => setDescritpion(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Check type="checkbox">
                        <FormCheck.Input
                          id="defaultCheck5"
                          className="me-2"
                          checked={reminder}
                          onChange={(e) => {
                            setReminder(e.target.checked);
                          }}
                        />
                        <FormCheck.Label
                          htmlFor="defaultCheck5"
                          className="mb-0"
                        >
                          Reminder Email
                        </FormCheck.Label>
                      </Form.Check>
                    </Col>
                    <div className="d-flex justify-content-between">
                      <Button
                        variant="primary"
                        onClick={handleBackClick}
                        className=" me-2"
                      >
                        <span>Back</span>
                      </Button>
                      {loadingBtn ? (
                        <div className="d-flex justify-content-start">
                          <Loadericon />
                        </div>
                      ) : (
                        <Button
                          variant="primary"
                          type="submit"
                          className=" me-2"
                        >
                          <span>Save</span>
                        </Button>
                      )}
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};
